import { useEffect, useState } from 'react';
import { logisticsOpsApi } from '../api/logisticsOps';

let cache = null;
let inflight = null;

export function __resetFeatureConfigCache() {
  cache = null;
  inflight = null;
}

export function useFeatureConfig() {
  const [config, setConfig] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let active = true;

    if (cache) {
      setConfig(cache);
      setLoading(false);
      return undefined;
    }

    inflight =
      inflight ||
      logisticsOpsApi
        .getFeatureConfig()
        .then((c) => {
          cache = {
            logisticsOpsEnabled: !!(c && c.logisticsOpsEnabled),
            assetMgmtEnabled: !!(c && c.assetMgmtEnabled),
          };
          return cache;
        })
        .catch(() => {
          cache = { logisticsOpsEnabled: false, assetMgmtEnabled: false };
          return cache;
        });

    inflight.then((c) => {
      if (active) {
        setConfig(c);
        setLoading(false);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return {
    logisticsOpsEnabled: !!(config && config.logisticsOpsEnabled),
    assetMgmtEnabled: !!(config && config.assetMgmtEnabled),
    loading,
  };
}
